<template>
  <nav class="menu">
    <template v-if="!isEmpty">
      <ul class="menu-nav" :class="{ opened: isShow }">
        <li class="menu-item menu-item_icon" @click="toggleMenu" :class="{ hover: 'close' === hoverAlias }">
          <span class="menu-item__burger icon icon-menu"></span>
        </li>
        <router-link
          v-for="route in navLinks"
          :data-testid="`menu-item-${route.name}`"
          :key="route.name"
          :to="route"
          :title="$t(`entity.${route.name}`)"
          class="menu-item menu-item_icon"
          :class="{ hover: route.name === hoverAlias }"
          tag="li"
        >
          <a
            v-if="route.name !== 'logging'"
            class="menu-item__link menu-item__icon icon"
            :class="`icon-${route.name === 'devicesAdmin' ? 'devices' : route.name}`"
          ></a>
          <svg-icon
            v-if="route.name === 'logging'"
            @click:icon="goToLogging"
            :name="route.name"
            class="svg-icon-size-3 mt-3"
          ></svg-icon>
        </router-link>
      </ul>
      <ul
        class="menu-nav menu-hidden"
        :class="{ show: isShow }"
        @mouseover="setHoverItem"
        @mouseleave="resetHoverItem"
      >
        <li class="menu-item" @click="toggleMenu">
          <span class="menu-item__link menu-item__back" data-alias="close">{{
            $t('src/views/navigation.5952')
          }}</span>
        </li>
        <router-link v-for="route in navLinks" :key="route.name" :to="route" class="menu-item" tag="li">
          <a class="menu-item__link" :data-alias="route.name">{{ $t(`entity.${route.name}`) }}</a>
        </router-link>
      </ul>

      <ul class="menu-nav">
        <router-link
          :to="{
            name: 'documents'
          }"
          :title="$t(`entity.docs`)"
          class="menu-item menu-item_icon"
          tag="li"
        >
          <svg-icon @click:icon="goToDocuments" :name="`document`" class="svg-icon-size-3 mt-3"></svg-icon>
        </router-link>
      </ul>
    </template>
  </nav>
</template>

<script>
import nav from '@/nav.json'
import { userRights } from '@/mixins/user-rights.js'
import '@/styles/components/menu.less'

export default {
  name: 'NavigationBar',
  mixins: [userRights],
  components: {
    SvgIcon: () => import('@/components/SvgIcon.vue')
  },
  data: () => ({
    isShow: false,
    hoverAlias: ''
  }),
  computed: {
    navLinks() {
      if (this.isNeuroAdmin) {
        return this.$store.getters.IS_SELECTED_HOSPITAL ? nav.admin : nav.neuro
      }
      if (this.isHospitalAdmin) {
        return nav.admin
      }
      if (this.isDoctor) {
        return nav.doctor
      }
      if (this.isReadonly) {
        return nav.readonly
      }

      return {}
    },
    isEmpty() {
      return Object.keys(this.navLinks).length === 0
    }
  },
  watch: {
    $route() {
      this.isShow = false
    }
  },
  methods: {
    toggleMenu() {
      this.isShow = !this.isShow
    },
    setHoverItem(e) {
      let link = e.target.closest('.menu-item__link')
      if (!link) {
        this.resetHoverItem()
        return
      }
      this.hoverAlias = link.dataset.alias
    },
    resetHoverItem() {
      this.hoverAlias = ''
    },
    goToLogging() {
      this.$router.push({
        name: 'logging'
      })
    },
    goToDocuments() {
      this.$router.push({
        name: 'documents'
      })
    }
  }
}
</script>
